var provider;

provider = require('lib/gdt_tables/cell_props_provider').provider;

module.exports = provider('className', _.str.dasherize);
